module.exports = require("pdfjs-dist/legacy/web/pdf_viewer");